import { MetastructureField, MetastructureFieldType } from '__types__';
import type { ResourceTypeFieldAssignment } from 'v5/api/resource-types/resource-type-bindings.api';

export function mapAssignmentsToMetastructureFields(
  assignments: ResourceTypeFieldAssignment[],
  previousFields: MetastructureField[] = []
): MetastructureField[] {
  const previousByKey = new Map<string, MetastructureField>();
  for (const field of previousFields) {
    if (field.type === MetastructureFieldType.Core) {
      previousByKey.set(`core:${field.name}`, field);
    } else if (field.type === MetastructureFieldType.Custom) {
      previousByKey.set(`custom:${field.custom_field_definition_id}`, field);
    }
  }

  const mapped: MetastructureField[] = assignments.map(assignment => {
    const previous = previousByKey.get(
      assignment.source === 'core'
        ? `core:${assignment.coreFieldKey}`
        : `custom:${assignment.customFieldDefinitionId}`
    );

    if (assignment.source === 'core') {
      return {
        type: MetastructureFieldType.Core,
        name: assignment.coreFieldKey,
        active: assignment.active,
        locked: assignment.locked,
        required: assignment.required,
        default: previous?.default ?? ''
      };
    }

    return {
      type: MetastructureFieldType.Custom,
      custom_field_definition_id: assignment.customFieldDefinitionId,
      active: assignment.active,
      locked: assignment.locked,
      required: assignment.required,
      default: previous?.default ?? ''
    };
  });

  // Preserve custom field groups from previous metastructure
  const groups = previousFields.filter(
    field => field.type === MetastructureFieldType.CustomGroup
  );
  return [...mapped, ...groups];
}
